const en = {
  // Navigation
  nav: {
    overview: 'Overview', inventory: 'Inventory', crm: 'CRM', wholesale: 'Wholesale',
    analytics: 'Analytics', vinDecoder: 'VIN Decoder', profitCalc: 'Profit Calc',
    aiTools: 'AI Tools', leadNetwork: 'Lead Network', salesInvoices: 'Sales/Invoices',
    expenses: 'Expenses', repairs: 'Repairs', docCenter: 'Doc Center', imagePro: 'Image Pro',
    importExport: 'Import/Export', settings: 'Settings', signOut: 'Sign Out',
  },
  // Landing Page
  landing: {
    hero: 'The Future of Dealer Technology',
    heroSub: 'Complete dealer management platform — inventory, CRM, AI tools, and vehicle history reports all in one place.',
    getStarted: 'Get Started Free',
    viewPricing: 'View Pricing',
    features: 'Features',
    pricing: 'Pricing',
    pricingTitle: 'Simple, Transparent Pricing',
    pricingSub: 'Start free for 7 days. No credit card required.',
    perMonth: '/mo',
    subscribe: 'Get Started',
    currentPlan: 'Current Plan',
    featuresTitle: 'Everything You Need',
    featuresSub: 'Built for modern dealers who want to win.',
    trustedBy: 'Trusted by 500+ dealers nationwide',
  },
  // Auth
  auth: {
    login: 'Sign In',
    register: 'Create Account',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    name: 'Full Name',
    companyName: 'Company / Dealership Name',
    phone: 'Phone Number',
    forgotPassword: 'Forgot Password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    resetPassword: 'Reset Password',
    sendResetLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    loggingIn: 'Signing in...',
    creating: 'Creating account...',
    startTrial: 'Start your free 7-day trial',
    resetSub: "Enter your email and we'll send you a reset link.",
  },
  // Dashboard
  dashboard: {
    title: 'Dashboard',
    totalVehicles: 'Total Vehicles',
    available: 'Available',
    inventoryValue: 'Inventory Value',
    conversionRate: 'Conversion Rate',
    searchVehicles: 'Search vehicles...',
    addVehicle: 'Add Vehicle',
    noVehicles: 'No vehicles found',
  },
  // VIN Decoder
  vin: {
    title: 'VIN Decoder',
    subtitle: 'Enter a 17-character VIN to decode',
    decode: 'Decode',
    enterVin: 'Enter 17-character VIN',
    wakzyCheck: 'Wakzy Check',
    wakzyCheckSub: 'Premium Vehicle History Report — powered by NHTSA data',
    runReport: 'Run Report',
    generating: 'Generating Wakzy Check Report...',
    generatingSub: 'Checking recalls, safety ratings, complaints & more',
    wakzyScore: 'Wakzy Score',
    noAccidents: 'No Accidents',
    cleanTitle: 'Clean Title',
    recalls: 'Recalls',
    owners: 'Owners',
    personalUse: 'Personal Use',
    safetyRating: 'Safety Rating',
    marketValue: 'Est. Market Value',
    expectedMileage: 'Expected Mileage',
    ownership: 'Ownership',
    estOwners: 'Est. Owners',
    usage: 'Usage',
    vehicleAge: 'Vehicle Age',
    years: 'years',
    scoreBreakdown: 'Wakzy Score Breakdown',
    safetySpecs: 'Safety & Specs',
    timeline: 'Timeline',
    complaints: 'Complaints',
    safetyRatings: 'Safety Ratings',
    safetyEquipment: 'Safety Equipment',
    vehicleSpecs: 'Vehicle Specifications',
    vehicleTimeline: 'Vehicle History Timeline',
    cleanHistory: 'Clean History',
    noEvents: 'No significant events found',
    safetyRecalls: 'Safety Recalls',
    noRecalls: 'No Recalls Found',
    consumerComplaints: 'Consumer Complaints',
    noComplaints: 'No Complaints Found',
    risk: 'Risk',
    fix: 'Fix',
    crashes: 'Crashes',
    fires: 'Fires',
    injuries: 'Injuries',
    print: 'Print',
    overall: 'Overall',
    frontalCrash: 'Frontal Crash',
    sideCrash: 'Side Crash',
    rollover: 'Rollover',
    notRated: 'Not Rated',
    bodyType: 'Body Type', engine: 'Engine', horsepower: 'Horsepower',
    transmission: 'Transmission', driveType: 'Drive Type', fuelType: 'Fuel Type',
    vehicleType: 'Vehicle Type', doors: 'Doors', trim: 'Trim', country: 'Country',
  },
  // Document Center
  docs: {
    title: 'Document Center',
    subtitle: 'Generate, manage & scan dealer documents',
    library: 'Library', generate: 'Generate', templates: 'Templates',
    signatures: 'Signatures', aiScanner: 'AI Scanner',
    upload: 'Upload', auditLog: 'Audit Log',
    total: 'Total', pending: 'Pending', expiring: 'Expiring',
    expired: 'Expired', missing: 'Missing',
    missingDocs: 'Missing Documents',
    searchDocs: 'Search VIN, stock #, customer, filename...',
    allTypes: 'All Types', allStatus: 'All Status',
    active: 'Active', archived: 'Archived',
    document: 'Document', type: 'Type', vinStock: 'VIN / Stock #',
    customer: 'Customer', status: 'Status', date: 'Date', actions: 'Actions',
    noDocs: 'No documents found',
    uploadFirst: 'Upload or generate your first document',
    generateDoc: 'Generate Document',
    generateClosing: 'Generate Closing Package',
    closingDesc: 'Bill of Sale + Odometer Disclosure + Buyer\'s Order — all in one print',
    template: 'Template', vehicle: 'Vehicle', selectVehicle: 'Select vehicle...',
    selectCustomer: 'Select customer...',
    salePrice: 'Sale Price', dealerFee: 'Dealer Fee', salesTax: 'Sales Tax',
    totalAmount: 'Total', paymentMethod: 'Payment Method', dateOfSale: 'Date of Sale',
    printSavePdf: 'Print / Save PDF',
    selectTemplate: 'Select a template and generate',
    autoFill: 'Documents auto-fill from vehicle & customer data',
    customTemplates: 'Custom Templates', newTemplate: 'New Template',
    noTemplates: 'No custom templates yet',
    createTemplates: 'Create reusable document templates for your dealership',
    saveTemplate: 'Save Template', updateTemplate: 'Update Template',
    addSection: 'Add Section', addField: 'Add Field',
    templateName: 'Name', accentColor: 'Accent Color', description: 'Description',
    autoFillPlaceholders: 'Auto-fill Placeholders',
    digitalSignatures: 'Digital Signatures',
    signaturesSub: 'Sign documents digitally — saved for reuse',
    createSignature: 'Create New Signature',
    savedSignatures: 'Saved Signatures',
    noSignatures: 'No saved signatures yet',
    scanDocument: 'Scan Document',
    scanSub: 'Upload a document image — AI extracts VIN, customer info & amounts',
    enterpriseFeature: 'Enterprise Plan Feature',
    extractedData: 'Extracted Data',
    scanResults: 'Scan results will appear here',
    applyToUpload: 'Apply to Upload Form',
    uploadDocument: 'Upload Document',
    chooseFile: 'Choose File',
    uploading: 'Uploading...',
  },
  // Image Pro
  imagePro: {
    title: 'Dealer Image Pro',
    subtitle: 'AI-Powered Car Photography Suite',
    dropOrClick: 'Drop an image or click to upload',
    allFormats: 'Supports ALL image formats — JPEG, PNG, WebP, HEIC, TIFF, BMP, AVIF',
    autoConvert: 'Non-standard formats auto-converted to JPEG',
    download: 'Download', share: 'Share', saveToLibrary: 'Save to Library',
    bgPresets: 'Background Presets', customBg: 'Custom Background',
    uploadBgImage: 'Upload Background Image',
    replaceBg: 'Replace Background', processing: 'Processing...',
    copyCaption: 'Copy Caption', websiteEmbed: 'Website Embed',
    sharePost: 'Share & Post',
  },
  // CRM
  crm: {
    contacts: 'Contacts', addContact: 'Add Contact', searchContacts: 'Search contacts...',
    name: 'Name', email: 'Email', phone: 'Phone', stage: 'Stage', source: 'Source',
    lastInteraction: 'Last Interaction', noContacts: 'No contacts found',
  },
  // Common
  common: {
    save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit', close: 'Close',
    confirm: 'Confirm', search: 'Search', filter: 'Filter', loading: 'Loading...',
    noData: 'No data', error: 'Error', success: 'Success', back: 'Back',
    next: 'Next', previous: 'Previous', submit: 'Submit', clear: 'Clear',
    selectAll: 'Select All', selected: 'selected', download: 'Download',
    yes: 'Yes', no: 'No', or: 'OR', and: 'and',
    language: 'Language',
  },
  admin: {
    overview: 'Overview', users: 'Users', idVerification: 'ID Verification',
    vehicles: 'Vehicles', revenue: 'Revenue', moderation: 'Moderation',
    announcements: 'Announcements', emailDigest: 'Email Digest',
    activityLog: 'Activity Log', systemHealth: 'System Health',
    platformSettings: 'Platform Settings', notifications: 'Notifications',
    signOut: 'Sign Out', totalUsers: 'Total Users', junkLeads: 'Junk Leads',
    estMrr: 'Est. MRR', thisWeek: 'this week', available: 'available',
    active: 'active', subscribers: 'subscribers', searchCmd: 'Search...',
  },
};

export default en;
